export default function PHP_get_browser() {
  return (
    <div>
      <h1>PHP_get_browser</h1>
    </div>
  );
}
